
import { useState } from 'react';

export default function HomePage() {
  const [language, setLanguage] = useState<'en' | 'pt'>('en');

  const content = {
    en: {
      hero: {
        title: '7 AI Agents to Automate Your Business',
        subtitle: 'ROI up to 2000% | From $149/month',
        button: 'See Packages'
      },
      packages: {
        starter: {
          badge: 'BEGINNER',
          title: 'STARTER',
          description: 'Choose 2 AI Agents | For small businesses',
          features: ['2 agents', 'Cancel anytime', 'PayPal'],
          button: 'BUY STARTER'
        },
        professional: {
          badge: 'MOST POPULAR',
          title: 'PROFESSIONAL',
          description: 'Choose 4 AI Agents | Best for growing businesses',
          features: ['4 agents', 'Save 17%', 'Priority support', 'Cancel anytime'],
          button: 'BUY PROFESSIONAL',
          save: 'Save $107/mo'
        },
        enterprise: {
          badge: 'BEST VALUE - 29% OFF',
          title: 'ENTERPRISE',
          description: 'ALL 7 Agents | Complete automation',
          features: ['All 7 agents', 'Save 29%', 'VIP support', 'Early access'],
          button: 'BUY ENTERPRISE',
          save: 'Save $344/mo'
        }
      },
      divider: 'Or choose individual agents',
      agents: {
        courseCreator: {
          title: 'Course Creator',
          description: 'Transform knowledge into courses automatically',
          features: 'Course structure, video scripts, slides, quizzes',
          button: 'BUY $189'
        },
        virtualAssistant: {
          title: 'Virtual Assistant',
          description: 'Schedule meetings, emails, tasks 24/7',
          features: 'Auto scheduling, email responses, task management',
          button: 'BUY $169',
          badge: 'NEW'
        },
        emailMarketing: {
          title: 'Email Marketing',
          description: 'Campaigns, segmentation, A/B testing auto',
          features: 'Auto campaigns, segmentation, A/B tests',
          button: 'BUY $159',
          badge: 'NEW'
        },
        adsOptimizer: {
          title: 'Ads Optimizer',
          description: 'Reduce 60-80% ad waste on Google & Meta',
          features: '24/7 optimization, Google+Meta, A/B testing',
          button: 'BUY $199'
        },
        whatsappSales: {
          title: 'WhatsApp Sales',
          description: 'Qualify leads, close sales 24/7 via WhatsApp',
          features: 'Instant responses, lead qualification, auto scheduling',
          button: 'BUY $179'
        },
        videoGenerator: {
          title: 'Video Generator',
          description: 'Create viral videos for Reels, TikTok, Shorts',
          features: '100 videos/mo, auto captions, music library',
          button: 'BUY $149'
        },
        copywriter: {
          title: 'Copywriter',
          description: 'Write VSL, sales letters, persuasive emails',
          features: 'Unlimited copy, VSL, AIDA/PAS formulas',
          button: 'BUY $149'
        }
      },
      footer: {
        tagline: 'Automate Your Business with AI',
        contact: 'Contact',
        security: '💳 Secure PayPal | Cancel anytime | No hidden fees',
        copyright: '© 2025 Readdy IA. All rights reserved.'
      }
    },
    pt: {
      hero: {
        title: '7 Agentes IA Para Automatizar Seu Negócio',
        subtitle: 'ROI até 2000% | A partir de $149/mês',
        button: 'Ver Pacotes'
      },
      packages: {
        starter: {
          badge: 'INICIANTE',
          title: 'STARTER',
          description: 'Escolha 2 Agentes IA | Para pequenos negócios',
          features: ['2 agentes', 'Cancele quando quiser', 'PayPal'],
          button: 'COMPRAR STARTER'
        },
        professional: {
          badge: 'MAIS POPULAR',
          title: 'PROFESSIONAL',
          description: 'Escolha 4 Agentes IA | Ideal para crescimento',
          features: ['4 agentes', 'Economize 17%', 'Suporte prioritário', 'Cancele quando quiser'],
          button: 'COMPRAR PROFESSIONAL',
          save: 'Economize $107/mês'
        },
        enterprise: {
          badge: 'MELHOR OFERTA',
          title: 'ENTERPRISE',
          description: 'TODOS 7 Agentes | Automação completa',
          features: ['Todos 7 agentes', 'Economize 29%', 'Suporte VIP', 'Acesso antecipado'],
          button: 'COMPRAR ENTERPRISE',
          save: 'Economize $344/mês'
        }
      },
      divider: 'Ou escolha agentes individuais',
      agents: {
        courseCreator: {
          title: 'Course Creator',
          description: 'Transforme conhecimento em cursos automaticamente',
          features: 'Estrutura de curso, scripts de vídeo, slides, quizzes',
          button: 'COMPRAR $189'
        },
        virtualAssistant: {
          title: 'Virtual Assistant',
          description: 'Agenda reuniões, emails, tarefas 24/7',
          features: 'Agendamento auto, respostas email, gestão tarefas',
          button: 'COMPRAR $169',
          badge: 'NOVO'
        },
        emailMarketing: {
          title: 'Email Marketing',
          description: 'Campanhas, segmentação, testes A/B auto',
          features: 'Campanhas auto, segmentação, testes A/B',
          button: 'COMPRAR $159',
          badge: 'NOVO'
        },
        adsOptimizer: {
          title: 'Ads Optimizer',
          description: 'Reduza 60-80% desperdício Google & Meta',
          features: 'Otimização 24/7, Google+Meta, testes A/B',
          button: 'COMPRAR $199'
        },
        whatsappSales: {
          title: 'WhatsApp Sales',
          description: 'Qualifica leads, fecha vendas 24/7 via WhatsApp',
          features: 'Respostas instantâneas, qualificação leads, agendamento auto',
          button: 'COMPRAR $179'
        },
        videoGenerator: {
          title: 'Video Generator',
          description: 'Crie vídeos virais Reels, TikTok, Shorts',
          features: '100 vídeos/mês, legendas auto, biblioteca música',
          button: 'COMPRAR $149'
        },
        copywriter: {
          title: 'Copywriter',
          description: 'Escreve VSL, cartas vendas, emails persuasivos',
          features: 'Copy ilimitado, VSL, fórmulas AIDA/PAS',
          button: 'COMPRAR $149'
        }
      },
      footer: {
        tagline: 'Automatize Seu Negócio com IA',
        contact: 'Contato',
        security: '💳 PayPal seguro | Cancele quando quiser | Sem taxas ocultas',
        copyright: '© 2025 Readdy IA. Todos os direitos reservados.'
      }
    }
  };

  const t = content[language];

  const scrollToPackages = () => {
    document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' });
  };

  const agents = [
    {
      icon: '🎓',
      key: 'courseCreator',
      roi: 'ROI 2000%+',
      price: '$189/mo',
      link: 'https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Course%20Creator&amount=189&currency_code=USD'
    },
    {
      icon: '🤖',
      key: 'virtualAssistant',
      roi: 'ROI 1800%+',
      price: '$169/mo',
      link: 'https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Virtual%20Assistant&amount=169&currency_code=USD'
    },
    {
      icon: '📧',
      key: 'emailMarketing',
      roi: 'ROI 1600%+',
      price: '$159/mo',
      link: 'https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Email%20Marketing&amount=159&currency_code=USD'
    },
    {
      icon: '📢',
      key: 'adsOptimizer',
      roi: 'ROI 1500%+',
      price: '$199/mo',
      link: 'https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Ads%20Optimizer&amount=199&currency_code=USD'
    },
    {
      icon: '💬',
      key: 'whatsappSales',
      roi: 'ROI 1100%+',
      price: '$179/mo',
      link: 'https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=WhatsApp%20Sales&amount=179&currency_code=USD'
    },
    {
      icon: '🎥',
      key: 'videoGenerator',
      roi: 'ROI 1200%+',
      price: '$149/mo',
      link: 'https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Video%20Generator&amount=149&currency_code=USD'
    },
    {
      icon: '✍️',
      key: 'copywriter',
      roi: 'ROI 1000%+',
      price: '$149/mo',
      link: 'https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Copywriter&amount=149&currency_code=USD'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-cyan-900">
      {/* Language Toggle */}
      <div className="fixed top-6 right-6 z-50 flex items-center gap-3 bg-white/10 backdrop-blur-md rounded-full px-4 py-2 border border-white/20">
        <button
          onClick={() => setLanguage('en')}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full transition-all whitespace-nowrap ${
            language === 'en' ? 'bg-white/20 text-white' : 'text-white/60 hover:text-white'
          }`}
        >
          <span className="text-lg">🇺🇸</span>
          <span className="font-medium text-sm">EN</span>
        </button>
        <div className="w-px h-4 bg-white/30"></div>
        <button
          onClick={() => setLanguage('pt')}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full transition-all whitespace-nowrap ${
            language === 'pt' ? 'bg-white/20 text-white' : 'text-white/60 hover:text-white'
          }`}
        >
          <span className="text-lg">🇧🇷</span>
          <span className="font-medium text-sm">PT</span>
        </button>
      </div>

      {/* Hero Section */}
      <div className="relative min-h-screen flex items-center justify-center px-6 py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40"></div>
        
        <div className="relative z-10 text-center max-w-5xl mx-auto">
          {/* Logo */}
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="text-6xl">🤖</span>
            <h1 className="text-5xl font-bold text-white">Readdy IA</h1>
          </div>

          {/* Title */}
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            {t.hero.title}
          </h2>

          {/* Subtitle */}
          <p className="text-2xl md:text-3xl text-cyan-300 mb-12 font-semibold">
            {t.hero.subtitle}
          </p>

          {/* CTA Button */}
          <button
            onClick={scrollToPackages}
            className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white px-12 py-4 rounded-full text-xl font-bold shadow-2xl hover:shadow-green-500/50 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            {t.hero.button}
          </button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>

      {/* Packages Section */}
      <div id="packages" className="relative px-6 py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            {/* Starter Package */}
            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:border-white/40 transition-all hover:transform hover:scale-105">
              <div className="flex items-center justify-between mb-6">
                <span className="text-4xl">💼</span>
                <span className="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                  {t.packages.starter.badge}
                </span>
              </div>

              <h3 className="text-3xl font-bold text-white mb-2">{t.packages.starter.title}</h3>
              
              <div className="mb-4">
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-white">$279</span>
                  <span className="text-white/60 text-lg">/mo</span>
                </div>
                <div className="text-white/40 line-through text-sm">$298+</div>
              </div>

              <p className="text-white/80 mb-6 text-sm leading-relaxed">
                {t.packages.starter.description}
              </p>

              <div className="space-y-3 mb-8">
                {t.packages.starter.features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2 text-white/90 text-sm">
                    <i className="ri-check-line text-green-400 text-lg"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <a
                href="https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Starter&amount=279&currency_code=USD"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-3 rounded-full font-bold text-center transition-all shadow-lg hover:shadow-green-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                {t.packages.starter.button}
              </a>
            </div>

            {/* Professional Package - Featured */}
            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-10 border-2 border-orange-500 hover:border-orange-400 transition-all transform lg:scale-110 shadow-2xl shadow-orange-500/30 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs font-bold px-4 py-2 rounded-full whitespace-nowrap animate-pulse flex items-center gap-2">
                  ⭐ {t.packages.professional.badge}
                </span>
              </div>

              <div className="flex items-center justify-between mb-6 mt-4">
                <span className="text-5xl">🚀</span>
                <span className="bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                  {t.packages.professional.save}
                </span>
              </div>

              <h3 className="text-4xl font-bold text-white mb-2">{t.packages.professional.title}</h3>
              
              <div className="mb-4">
                <div className="flex items-baseline gap-2">
                  <span className="text-5xl font-bold text-white">$529</span>
                  <span className="text-white/60 text-xl">/mo</span>
                </div>
                <div className="text-white/40 line-through text-sm">$636+</div>
              </div>

              <p className="text-white/90 mb-6 leading-relaxed">
                {t.packages.professional.description}
              </p>

              <div className="space-y-3 mb-8">
                {t.packages.professional.features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2 text-white text-sm">
                    <i className="ri-check-line text-green-400 text-xl"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <a
                href="https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Professional&amount=529&currency_code=USD"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-4 rounded-full font-bold text-center transition-all shadow-xl hover:shadow-green-500/50 hover:scale-105 text-lg whitespace-nowrap cursor-pointer"
              >
                {t.packages.professional.button}
              </a>
            </div>

            {/* Enterprise Package */}
            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:border-white/40 transition-all hover:transform hover:scale-105">
              <div className="flex items-center justify-between mb-6">
                <span className="text-4xl">👑</span>
                <span className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                  {t.packages.enterprise.badge}
                </span>
              </div>

              <h3 className="text-3xl font-bold text-white mb-2">{t.packages.enterprise.title}</h3>
              
              <div className="mb-4">
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-white">$849</span>
                  <span className="text-white/60 text-lg">/mo</span>
                </div>
                <div className="text-white/40 line-through text-sm">$1,193</div>
                <div className="text-orange-400 font-semibold text-sm mt-1">{t.packages.enterprise.save}</div>
              </div>

              <p className="text-white/80 mb-6 text-sm leading-relaxed">
                {t.packages.enterprise.description}
              </p>

              <div className="space-y-3 mb-8">
                {t.packages.enterprise.features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2 text-white/90 text-sm">
                    <i className="ri-check-line text-green-400 text-lg"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <a
                href="https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=yara_mg1@hotmail.com&item_name=Enterprise&amount=849&currency_code=USD"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-3 rounded-full font-bold text-center transition-all shadow-lg hover:shadow-green-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                {t.packages.enterprise.button}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="relative px-6 py-12">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center gap-4 justify-center">
            <div className="h-px bg-gradient-to-r from-transparent via-white/30 to-transparent flex-1 max-w-xs"></div>
            <h3 className="text-2xl font-bold text-white whitespace-nowrap">{t.divider}</h3>
            <div className="h-px bg-gradient-to-r from-transparent via-white/30 to-transparent flex-1 max-w-xs"></div>
          </div>
        </div>
      </div>

      {/* Individual Agents Section */}
      <div className="relative px-6 py-12 pb-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {agents.map((agent) => {
              const agentData = t.agents[agent.key as keyof typeof t.agents];
              return (
                <div
                  key={agent.key}
                  className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20 hover:border-white/40 transition-all hover:transform hover:scale-103 relative"
                >
                  {agentData.badge && (
                    <div className="absolute -top-3 -right-3">
                      <span className="bg-gradient-to-r from-green-500 to-emerald-600 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap animate-pulse">
                        ⭐ {agentData.badge}
                      </span>
                    </div>
                  )}

                  <div className="flex items-center justify-between mb-4">
                    <span className="text-4xl">{agent.icon}</span>
                    <span className="bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded-full whitespace-nowrap">
                      {agent.roi}
                    </span>
                  </div>

                  <h4 className="text-xl font-bold text-white mb-2">{agentData.title}</h4>
                  
                  <div className="mb-3">
                    <span className="text-2xl font-bold text-white">{agent.price}</span>
                  </div>

                  <p className="text-white/80 mb-4 text-sm leading-relaxed">
                    {agentData.description}
                  </p>

                  <div className="mb-6">
                    <p className="text-white/70 text-xs leading-relaxed">
                      {agentData.features}
                    </p>
                  </div>

                  <a
                    href={agent.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-2.5 rounded-full font-bold text-center transition-all shadow-lg hover:shadow-green-500/50 hover:scale-105 text-sm whitespace-nowrap cursor-pointer"
                  >
                    {agentData.button}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative py-12 px-6 border-t border-white/10 bg-slate-900/50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="text-5xl">🤖</span>
              <h3 className="text-3xl font-bold text-white">Readdy IA</h3>
            </div>
            <p className="text-white/80 text-lg mb-6">{t.footer.tagline}</p>
            
            <div className="mb-6">
              <p className="text-white/60 text-sm mb-2">{t.footer.contact}</p>
              <a 
                href="mailto:yara_mg1@hotmail.com" 
                className="text-cyan-400 hover:text-cyan-300 transition-colors text-lg font-medium cursor-pointer"
              >
                📧 yara_mg1@hotmail.com
              </a>
            </div>

            <div className="mb-6">
              <p className="text-white/70 text-sm">{t.footer.security}</p>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 text-center">
            <p className="text-white/60 text-sm">
              {t.footer.copyright} | <a href="https://readdy.ai/?origin=logo" className="text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
